import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Img } from 'react-image';
import dt from '../../../shared/theme';

const Container = styled.div`
  width: 216px;
  height: 204px;
  background-color: ${props => props.theme.bodyColor};
  border: none;
  border-radius: 5px;
  box-shadow: 0 0 30px ${props => props.theme.secondaryColor30Transparent};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
  padding: 0 13px 13px 27px;

  ${props => (props.theme.isMobile && `
    margin: 20px 0;
  `)};

  ${props => dt(props).theme.isXLarge && `
    margin: 0 45px;
  `};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const Head = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
`;

const popup = 16;
const Headshot = styled(Img)`
  width: 60px;
  height: 60px;
  box-shadow: 0 3px 20px rgba(0, 0, 0, .16);
  position: relative;
  top: -${popup}px;
`;

const Logo = styled(Img)`
  width: 78px;
  height: 30px;
  position: relative;
  bottom: ${popup}px;
`;

const Texta = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  color: white;
  text-align: left;
  font-size: 14px;
  line-height: 15px;
`;

const Name = styled(Texta)`
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightHeavy};
  margin-top: 6px;
  width: 100%;
  display: flex;
  flex-direction: column;

  &:after {
    margin-top: 12px;
    font-size: 32px;
    content: "\\201c";
    color: ${props => props.theme.primaryColor};
    order: 1;
  }

  &:before {
    content: "";
    width: 153px;
    height: 0;
    position: relative;
    top: -14px;
    left: 23px;
    border: none;
    border-bottom: 1px solid ${props => props.theme.secondaryColor};
    order: 2;
  }
`;

const Says = styled(Texta)`
  font-weight: ${props => props.theme.fontWeightMedium};
  font-style: italic;
`;

export default function Tile(props) {
  const {
    logo, headshot, name, says,
  } = props;

  return (
    <Container>
      <Head>
        <Headshot src={headshot} />
        <Logo src={logo} />
      </Head>
      <Name>{name}</Name>
      <Says>{says}</Says>
    </Container>
  );
}

Tile.propTypes = {
  logo: PropTypes.string.isRequired,
  headshot: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  says: PropTypes.string.isRequired,
};
